import React, { useState, useRef, useEffect } from "react";

import { PictureUploadWrapper } from "./style";
import icon from "../../images/uploadIcon.svg";
import { isEmpty } from "../../Utils/common";
import fileIcon from "../../images/file.png";

const PictureUpload = ({
  setImage = () => { },
  image = "",
  accept = "image/jpeg,image/png,image/jpg",
  type = "image",
}) => {
  const [fileName, setFileName] = useState(null);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    try {
      const selectedFile = event.target.files[0];
      // setFile(selectedFile);
      setImage(selectedFile);
      setFileName(selectedFile.name);

      setPreview(URL.createObjectURL(selectedFile));
    } catch (error) { }
  };

  const handleDrop = (event) => {
    try {
      event.preventDefault();
      const droppedFile = event.dataTransfer.files[0];
      // setFile(droppedFile);
      setImage(droppedFile);
      setFileName(droppedFile.name);
      setPreview(URL.createObjectURL(droppedFile));
    } catch (error) { }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    // setFile(null);
    setImage(null);
    setPreview("");
    setFileName("");
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    if (isEmpty(image)) return;
    setPreview(image);
  }, [image]);

  console.log("preview", preview);
  return (
    // <PictureUploadWrapper
    //   className="file-upload"
    //   onDrop={handleDrop}
    //   onDragOver={handleDragOver}
    //   onClick={handleClick}
    // >
    //   {preview ? (
    //     <>
    //       {type === "image" ? (
    //         <div className="preview-container">
    //           <img
    //             src={preview}
    //             alt="Preview"
    //             style={{ width: "100%", height: "auto" }}
    //           />
    //           <span className="remove-icon" onClick={handleRemove}>
    //             &#10005;
    //           </span>
    //         </div>
    //       ) : (
    //         <div className="showTextImg">
    //           <div>
    //             <span className="remove-icon" onClick={handleRemove}>
    //               &#10005;
    //             </span>
    //             <img src={fileIcon} alt="" />
    //             <p
    //               style={{
    //                 marginInline: "0",
    //                 maxWidth: "100%",
    //                 textAlign: "center",
    //                 marginTop: "20px",
    //               }}
    //             >
    //               {fileName}
    //             </p>
    //           </div>
    //         </div>
    //       )}
    //     </>
    //   ) : (
    //     <div className="showTextImg">
    //       <div>
    //         <img src={type === "image" ? icon : fileIcon} alt="" />
    //         <p style={{ padding: "20px" }}>
    //           Drag & Drop your file here or click to select a file
    //         </p>
    //       </div>
    //     </div>
    //   )}
    //   <input
    //     type="file"
    //     ref={fileInputRef}
    //     onChange={handleFileChange}
    //     accept={accept}
    //     style={{ display: "none" }}
    //   />
    // </PictureUploadWrapper>
    <PictureUploadWrapper
      className="w-full min-h-[180px] sm:min-h-[220px] md:min-h-[260px]
             border-2 border-dashed border-gray-300 rounded-2xl
             p-4 sm:p-6 flex items-center justify-center
             cursor-pointer transition-all duration-300 hover:border-blue-500"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      {preview ? (
        <>
          {type === "image" ? (
            <div className="relative w-full flex justify-center">
              <img
                src={preview}
                alt="Preview"
                className="w-full max-h-72 object-contain rounded-lg"
              />

              <button
                type="button"
                onClick={handleRemove}
                className="absolute top-2 right-2 w-8 h-8 rounded-full
                       bg-red-500 text-white flex items-center justify-center
                       hover:bg-red-600"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="relative flex flex-col items-center text-center w-full">
              <button
                type="button"
                onClick={handleRemove}
                className="absolute top-0 right-0 w-8 h-8 rounded-full
                       bg-red-500 text-white flex items-center justify-center
                       hover:bg-red-600"
              >
                ✕
              </button>

              <img
                src={fileIcon}
                alt=""
                className="w-14 h-14 sm:w-16 sm:h-16"
              />

              <p className="mt-4 text-sm sm:text-base text-gray-700 break-all px-2">
                {fileName}
              </p>
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center text-center w-full">
          <img
            src={type === "image" ? icon : fileIcon}
            alt=""
            className="w-14 h-14 sm:w-16 sm:h-16"
          />

          <p className="mt-4 text-sm sm:text-base text-gray-500 px-4 leading-6">
            Drag & Drop your file here
            <br />
            <span className="text-blue-600 font-medium">
              or click to select a file
            </span>
          </p>
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        className="hidden"
      />
    </PictureUploadWrapper>
  );
};

export default PictureUpload;
